import { render, staticRenderFns } from "./ProjectTrends.vue?vue&type=template&id=431bf79c&scoped=true&"
import script from "./ProjectTrends.vue?vue&type=script&lang=js&"
export * from "./ProjectTrends.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTrends.vue?vue&type=style&index=0&id=431bf79c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431bf79c",
  null
  
)

export default component.exports